module.exports = __webpack_public_path__ + "img/sig.b715eea7.svg";